import { zodValidator } from '@tanstack/zod-adapter';
import { Payments } from '@anytag/app';
import { PaymentsSearchSchema } from '@anytag/shared-organisms';
import { PartialRouter } from '../../types';

export const PaymentsRouter = {
  '/_private-routes/payments': [Payments, { validateSearch: zodValidator(PaymentsSearchSchema) }]
} as const satisfies PartialRouter;
